import * as modal from 'smg/modal';
import * as offcanvas from 'smg/offcanvas';
import { Debounce } from 'smg/util';

export type Options = modal.Options & offcanvas.Options & { modal?: modal.Options; offcanvas?: offcanvas.Options };

export class ModalOrOffcanvas {
    private modal: modal.default | undefined;
    private offcanvas: offcanvas.default | undefined;

    constructor(private opts: Options) {
        this.opts.cancelButton ??= false;

        this.opts.modal = {
            ...this.opts,
            ...this.opts.modal,
        };

        this.opts.offcanvas = {
            ...this.opts,
            ...this.opts.offcanvas,
        };

        this.opts.offcanvas.placement ??= 'bottom';

        this.Show();
    }

    public Show() {
        if (window.innerWidth < 768) {
            this.offcanvas = new offcanvas.default(this.opts.offcanvas);
            void this.offcanvas.ClosedPromise.then(() => {
                window.removeEventListener('resize', resize);
            });
        } else {
            this.modal = new modal.default(this.opts.modal);
            void this.modal.ClosedPromise.then(() => {
                window.removeEventListener('resize', resize);
            });
        }

        const debounce = Debounce(() => this.Show(), 500, false);
        let width = window.innerWidth;
        const resize = () => {
            if (width === window.innerWidth) {
                return;
            }
            width = window.innerWidth;

            this.modal?.Close();
            delete this.modal;

            this.offcanvas?.Close();
            delete this.offcanvas;

            debounce();
        };
        window.addEventListener('resize', resize);
    }

    public Close() {
        this.modal?.Close();
        this.offcanvas?.Close();
    }

    public get element() {
        return this.modal?.Element ?? this.offcanvas?.Element;
    }
}